<template>
  <div
    class="brand-login-hero"
    role="img"
    aria-label="Zyncro, tu gestión comercial en un solo lugar"
  >
    <div class="brand-login-hero-grid" aria-hidden="true" />
    <div class="brand-login-hero-glow" aria-hidden="true" />

    <div class="brand-login-hero-inner">
      <div class="brand-login-hero-brand" aria-label="Zyncro">
        <span
          class="brand-login-hero-icon"
          :style="maskStyle(branding.defaultIcon)"
          aria-hidden="true"
        />
        <span
          class="brand-login-hero-wordmark"
          :style="maskStyle(branding.defaultWordmark)"
          aria-hidden="true"
        />
      </div>
      <p class="brand-login-hero-title">Tu gestión comercial, en un solo lugar</p>
    </div>
  </div>
</template>

<script>
import Session from '@/handler/session'
import { EventBus } from '@/handler/event-bus'
import Branding from './branding'

export default {
  name: 'BrandLoginHero',
  data() {
    const session = Session.getSession()
    return {
      branding: Branding.resolve(session && session.settings),
    }
  },
  created() {
    EventBus.$on('Settings:settings', this.refreshBranding)
  },
  mounted() {
    this.refreshBranding()
  },
  beforeDestroy() {
    EventBus.$off('Settings:settings', this.refreshBranding)
  },
  methods: {
    refreshBranding() {
      const session = Session.getSession()
      this.branding = Branding.resolve(session && session.settings)
    },
    maskStyle(source) {
      return {
        '--brand-login-mask': `url("${source}")`,
      }
    },
  },
}
</script>

<style scoped>
.brand-login-hero {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background:
    radial-gradient(circle at 42% 48%, rgba(104, 87, 255, 0.26) 0%, rgba(104, 87, 255, 0) 24%),
    linear-gradient(180deg, #141a57 0%, #171e63 54%, #2a2b88 100%);
}

.brand-login-hero-grid,
.brand-login-hero-glow {
  position: absolute;
  inset: 0;
}

.brand-login-hero-grid {
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.035) 1px, transparent 1px);
  background-size: 64px 64px;
}

.brand-login-hero-glow {
  background: radial-gradient(circle at 42% 48%, rgba(53, 210, 245, 0.08) 0%, rgba(53, 210, 245, 0) 30%);
}

.brand-login-hero-inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 3rem;
  text-align: center;
}

.brand-login-hero-brand {
  display: inline-flex;
  align-items: center;
  gap: 1.5rem;
}

.brand-login-hero-icon,
.brand-login-hero-wordmark {
  display: block;
  flex-shrink: 0;
  background-color: #35d2f5;
  -webkit-mask-image: var(--brand-login-mask);
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  mask-image: var(--brand-login-mask);
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
}

.brand-login-hero-icon {
  width: 10vw;
  max-width: 150px;
  height: 10vw;
  max-height: 150px;
}

.brand-login-hero-wordmark {
  width: 28vw;
  max-width: 380px;
  height: 7vw;
  max-height: 90px;
  transform: translateY(10px);
}

.brand-login-hero-title {
  margin: 1.65rem 0 0;
  color: #69e1f4;
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

@media (max-width: 1100px) {
  .brand-login-hero-inner {
    padding: 2rem;
  }

  .brand-login-hero-brand {
    gap: 1rem;
  }

  .brand-login-hero-wordmark {
    transform: translateY(7px);
  }

  .brand-login-hero-title {
    font-size: 1.45rem;
  }
}
</style>
